<template>
    <Chips
        :modelValue="value"
        @add="
            $emit(
                'handleValueChange',
                $event.value.map((element) => element.trim())
            )
        "
        @remove="
            $emit(
                'handleValueChange',
                value.filter((x) => x != $event.value)
            )
        "
        separator=";"
        :placeholder="placeholderText()"
        addOnBlur
    />
</template>

<script>
export default {
    name: 'TextRule',
    props: ['value'],
    methods: {
        placeholderText() {
            if (this.value) {
                return null;
            }
            return 'use semicolons to separate values';
        },
    },
};
</script>

<style scoped></style>
